export default function Footer() {
  return (
    <footer className="bg-[#1a0f0a] text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* 로고 및 소개 */}
          <div className="space-y-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-white"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    d="M12 3L3 8L12 13L21 8L12 3Z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path d="M3 13L12 18L21 13" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M7 8V20M17 8V20" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold font-playfair ml-3">법무법인 휘상</h3>
            </div>
            <p className="text-white/70 font-nanum-myeongjo">
              전문성과 신뢰성으로 고객의 권리를 지키는 법무법인 휘상입니다.
            </p>
          </div>

          {/* 연락처 */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold font-noto-sans">연락처</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-[#b98e6a] mt-1"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    d="M3 5.5C3 14.0604 9.93959 21 18.5 21C19.3405 21 20.1481 20.8977 20.9167 20.7083"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 3L16.5 7.5M21 3V8.5M21 3H15.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div>
                  <p className="font-medium">전화</p>
                  <p className="text-white/70">02-6959-2170</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-[#b98e6a] mt-1"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    d="M21 10C21 13.866 17.866 17 14 17H10C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3H14C17.866 3 21 6.13401 21 10Z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div>
                  <p className="font-medium">이메일</p>
                  <p className="text-white/70">hwisang@hwisang.co.kr</p>
                </div>
              </div>
            </div>
          </div>

          {/* 주소 */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold font-noto-sans">주소</h4>
            <div className="flex items-start gap-3">
              <svg
                className="w-5 h-5 text-[#b98e6a] mt-1"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M21 10C21 10 19 14 12 14C5 14 3 10 3 10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div>
                <p className="text-white/70 font-nanum-myeongjo">
                  서울 강남구 영동대로 611
                  <br />
                  13층 (찬앤찬타워)
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 구분선 */}
        <div className="border-t border-white/10 my-12"></div>

        {/* 저작권 */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm font-nanum-gothic">
            © 2025 법무법인 휘상. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a
              href="/privacy-policy"
              className="text-white/50 hover:text-white text-sm font-nanum-gothic transition-colors"
            >
              개인정보처리방침
            </a>
            <a
              href="/terms"
              className="text-white/50 hover:text-white text-sm font-nanum-gothic transition-colors"
            >
              이용약관
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
